import type { IHttpClient } from '@wix/fe-essentials/http-client';
import { createContext, useContext } from 'react';

export interface HttpClientProps {
  httpClient?: IHttpClient;
}

export const HttpClientContext = createContext<HttpClientProps | undefined>(
  undefined,
);

export function useHttpClient() {
  const context = useContext(HttpClientContext);
  if (context === undefined) {
    throw new Error('useHttpClient must be used within a HttpClientProvider');
  }
  return context;
}
